import { translate } from "../i18n/index.js";
/**
 * حدود المرفقات — **تعريف واحد يقرؤه السيرفر والشاشة**.
 *
 * ولو عاش الحدّ في السيرفر وحده لكتبت الشاشة رقماً بجواره؛ فإذا تغيّر أحدهما
 * قالت الشاشة «الحد الأقصى ٧٠» ورفض السيرفر عند ٥٠ — وهي الرسالة الكاذبة
 * التي لا يصدّقها المستخدم بعدها في شيء.
 */
/**
 * **ما يُعرَض داخل الشاشة** — قائمةٌ بيضاء بنوعها، وما عداها تنزيلٌ وحده.
 *
 * فالملفُّ يُخدَم من أصل النظام نفسه، **وملفُّ HTML أو SVG يُفتَح داخله ينفّذ كوداً بجلسة من
 * فتحه**. فلا يُعرَض إلا صورةٌ نقطيةٌ أو فيديو، **ويُرسَل نوعُه مفروضاً** لا كما ادّعاه رافعه.
 */
const INLINE_IMAGES = ["image/png", "image/jpeg", "image/webp", "image/gif"];
const INLINE_VIDEOS = ["video/mp4", "video/webm", "video/quicktime"];
export function inlineMediaKind(contentType) {
    const type = (contentType ?? "").split(";")[0]?.trim().toLowerCase() ?? "";
    if (INLINE_IMAGES.includes(type))
        return "image";
    if (INLINE_VIDEOS.includes(type))
        return "video";
    return null;
}
/** حدّ حجم المرفق — **قرار شادي ٢٠٢٦-٠٩-٢٤**: سبعون ميجا */
export const MAX_ATTACHMENT_MB = 70;
export const MAX_ATTACHMENT_BYTES = MAX_ATTACHMENT_MB * 1024 * 1024;
/**
 * حجم الملف كما يقرؤه بشر — **مفتاحٌ وقيمة، لا نصّاً**.
 *
 * فالوحدة نصٌّ يراه المستخدم، ومكانها القاموس باللغتين لا سطرٌ في شاشة.
 *
 * ويُقرَّب لأعلى دون الميجا: ملفٌ حجمه ٣٣٥ بايت كان يُعرَض **«0 KB»** — رقمٌ
 * يقول لصاحبه إن ملفه فارغ وهو ليس كذلك. والصفر الكاذب أسوأ من لا رقم.
 */
export function fileSizeParts(bytes) {
    if (!Number.isFinite(bytes) || bytes < 0)
        return { key: "units.bytes", n: 0 };
    if (bytes < 1024)
        return { key: "units.bytes", n: Math.round(bytes) };
    if (bytes < 1024 * 1024)
        return { key: "units.kilobytes", n: Math.ceil(bytes / 1024) };
    return { key: "units.megabytes", n: Math.round((bytes / 1024 / 1024) * 10) / 10 };
}
/**
 * **حجمُ الملف نصّاً جاهزاً** — فلا يُنسَى تمريرُ الرقم إلى الوحدة.
 *
 * ومفتاحُ الوحدة **عبارةٌ كاملة** (`{n} ميجا`) لا وحدةٌ مجرّدة، لأن موضع الرقم
 * يختلف بين اللغتين. فمن كتب `${n} ${t(key)}` طبع `{n}` حرفياً على الشاشة —
 * وهو ما فعلتُه في شاشة التخزين، **وظهر بالنقر لا بالاختبار**: «2.3 {n} ميجا».
 *
 * وثلاثةُ مواضع كانت تُنسّق بيدها، فنزل الموضع الواحد قبل الرابع.
 */
export function fileSizeText(locale, bytes) {
    const parts = fileSizeParts(bytes);
    return translate(locale, parts.key, { n: parts.n });
}
export function isServableAttachment(scan) {
    return scan !== "PENDING" && scan !== "REJECTED";
}
/**
 * **رابطٌ بكلامٍ يُقرأ — لا عنوانٌ كامل.**
 *
 * فالمعاينةُ والتسليمُ والريفرنسُ روابطُ في الغالب، وكانت تُعرَض
 * `https://drive.example.com/file/d/1Abc…/view?usp=sharing` كما هي: سطرٌ لا ينتهي
 * يكسر الصفّ ولا يقول شيئاً. فيُقال **موقعُه وآخرُ اسمٍ فيه** — «drive.example.com/…/reel-2»
 * كما في موك أب الخطط — والرابطُ الكامل يبقى ما يُفتَح.
 *
 * **ونصٌّ ليس رابطاً يُعرَض كما هو** — فلا يُخفى ما كتبه إنسان.
 */
export function linkLabel(url) {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch (_) {
        return url;
    }
    const host = parsed.hostname.replace(/^www\./, "");
    const parts = parsed.pathname.split("/").filter((part) => part !== "");
    const last = parts.at(-1);
    if (last === undefined)
        return host;
    const readable = (() => {
        try {
            return decodeURIComponent(last);
        }
        catch (_) {
            return last;
        }
    })();
    return parts.length > 1 ? `${host}/…/${readable}` : `${host}/${readable}`;
}
//# sourceMappingURL=index.js.map